var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewTag1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 49,
    viewBox: "0 0 64 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#723pijt1wa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.791 21.981H5.493v24.12H57.79V21.98z",
    fill: "#4D2626",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m59.415.348.287-.098H3.339C5.206.25 6.72 11.851 6.72 26.16c0 8.022-.475 15.19-1.223 19.943C8.55 47.39 25.574 48.25 31.933 48.25c6.78 0 22.968-.719 25.858-2.15-.723-4.752-1.466-12.064-1.466-19.94 0-13.554 1.359-24.678 3.09-25.812z",
    fill: "url(#d1phlcpdcb)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.339.25C1.655.25.26 9.659 0 21.981h6.677C6.414 9.66 5.02.25 3.339.25z",
    fill: "url(#l2onscsayc)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.706.25c-1.68 0-3.078 9.409-3.338 21.731h6.677C62.785 9.66 61.39.25 59.706.25z",
    fill: "url(#p3e7tbhb3d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.065 19.097h2.262l5.09 8.79v-8.79h2.277v13.6h-2.276l-5.091-8.79v8.79h-2.262v-13.6zM27.157 21.73v2.713h5.309v2.634h-5.309v2.99h5.86v2.634H24.88v-13.6h8.138v2.634h-5.86v-.004zM34.004 19.097h2.462l1.953 9.127 2.338-9.127h2.462l2.338 9.127 1.953-9.127h2.462l-3.2 13.6h-2.275l-2.493-9.345-2.508 9.345h-2.293l-3.2-13.6z",
    fill: "#FFD500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d1phlcpdcb",
    x1: 31.52,
    y1: 48.25,
    x2: 31.52,
    y2: 0.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l2onscsayc",
    x1: 3.339,
    y1: 21.981,
    x2: 3.339,
    y2: 0.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "maroon"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p3e7tbhb3d",
    x1: 59.706,
    y1: 0.25,
    x2: 59.706,
    y2: 0.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "maroon"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#300"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "723pijt1wa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .25)",
    d: "M0 0h63.045v48H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTag1);
export default __webpack_public_path__ + "static/media/new_tag_1.1399d42c2ea620f7562b33d189180d25.svg";
export { ForwardRef as ReactComponent };